import React, { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { LoadingPage } from '../LoadingPage'
import { useNavigate } from 'react-router-dom'
import { ContractorPortalSecureWrapper } from 'src/components/layout/contractorPortal/ContractorPortalSecureWrapper'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import {
  getContractorPortalDocuments,
  getContractorPortalDocumentsCount,
} from 'src/selectors/contractorPortal'
import { ContractorPortalDocumentItem } from 'src/components/contractor-portal/contractor-document/ContractorPortalDocumentItem'
import { CONTRACTOR_PORTAL_ROUTES } from 'src/constants/routes'
import EmptyImage from 'src/assets/images/empty-doc.svg'
import { getPartner } from 'src/selectors/partner'
import { getDriver } from 'src/selectors/driver'
import { Footer } from 'src/components/shared/Footer'
import { Button } from 'src/components/shared/Button'

const ContractorPortalDocumentsPageComponent = () => {
  const navigate = useNavigate()

  const driver = useSelector(getDriver)
  const partner = useSelector(getPartner)
  const documents = useSelector(getContractorPortalDocuments)
  const documentsCount = useSelector(getContractorPortalDocumentsCount)

  const handleBack = useCallback(() => {
    navigate(CONTRACTOR_PORTAL_ROUTES.HOME_URL)
  }, [])

  if (!driver) {
    return <LoadingPage flow="contractorPortal" />
  }

  return (
    <ContractorPortalSecureWrapper>
      <div css={tw`w-full px-4 pt-20 lg:pt-6 pb-12`}>
        <Button
          css={tw`bg-primary-100 h-[42px] w-[82px] hover:bg-primary-200`}
          color="light"
          size="medium"
          leftIcon={<ChevronLeftMinor width={19} css={tw`fill-primary-500`} />}
          onClick={handleBack}
          data-testid="header-nav-back-btn"
        >
          Back
        </Button>
        <Typography variant="h2" css={tw`mb-2 mt-6`}>
          Your documents
        </Typography>
        <Typography css={tw`mb-6 text-shades-400`}>
          {`${partner?.displayName} • ${documentsCount} documents`}
        </Typography>
        {documents.length ? (
          <div
            css={tw`bg-shades-0 rounded-2xl overflow-hidden`}
            data-testid="contractors-list-documents-table"
          >
            {documents.map((item, index) => (
              <ContractorPortalDocumentItem
                key={item.id}
                document={item}
                isFirstItem={index === 0}
              />
            ))}
          </div>
        ) : (
          <div css={tw`bg-shades-0 rounded-2xl p-10 flex flex-col`}>
            <img css={tw`self-center`} src={EmptyImage} />
            <Typography css={tw`self-center mt-4 mb-0.5`} variant="h4">
              This board is empty
            </Typography>
            <Typography css={tw`text-center text-shades-400`} variant="body2">
              You haven't received any documents yet. Check back later for updates.
            </Typography>
          </div>
        )}
      </div>
      <Footer
        className={tw`flex mt-auto items-center px-4 pt-2 pb-8 bg-shades-50 justify-center w-full`}
      />
    </ContractorPortalSecureWrapper>
  )
}

export const ContractorPortalDocumentsPage = memo(ContractorPortalDocumentsPageComponent)
